@if (cardData) {
    <div [ngClass]="{'clickable': linkText, 'show-caret': showCaret}" class="drawer-card" [finderScrollTo]="elementId" (click)="click($event)">
        <div class="drawer-image">
            <finder-picture [picture]="cardData.media" class="drawer-pic"></finder-picture>
        </div>
        <div class="drawer-info">
            <h3 class="drawer-title" [innerHTML]="cardData.title | safeHtml"></h3>
            @if (cardData.subtitle) {
                <span class="drawer-subtitle" [innerHTML]="cardData.subtitle | safeHtml"></span>
            }
            <div class="drawer-more">
                @if (cardData.viewMoreText) {
                    <finder-button
                        anchor="true"
                        [id]="linkId"
                        ariaLabel="{{ linkText }} - {{ cardData.ariaLabel }}"
                        [ariaExpanded]="isExpanded"
                        [ariaControls]="elementId"
                        (click)="click($event);">
                        <span>{{linkText}}</span>
                    </finder-button>
                    @if (buttonIconsEnabled) {
                        @if (isExpanded) {
                            <finder-font-icon name="norgie-up" size="s"></finder-font-icon>
                        } @else if (!isExpanded) {
                            <finder-font-icon name="norgie-opened" size="s"></finder-font-icon>
                        }
                    }
                } @else if (cardData.storyCardLink) {
                    <finder-anchor
                        [href]="cardData.storyCardLink">
                        <span>{{cardData.storyCardTitle}}</span>
                        @if (buttonIconsEnabled) {
                            <finder-font-icon
                                style="transform: scaleX(-1);"
                                size="s"
                                class="away-arrow"
                                name="return-arrow">
                            </finder-font-icon>
                        }
                    </finder-anchor>
                }
            </div>
            <div
                class="detail-contents"
                [attr.aria-hidden]="!isExpanded"
                [innerHTML]="cardData.viewMoreSubtitle | safeHtml"
                inert>
            </div>
        </div>
    </div>
}
